"use client"

import { TabletSmartphone } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `TabletSmartphoneIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const TabletSmartphoneIcon = component(Icon)({ as: TabletSmartphone })
